import { DashboardOperationsButtons as CoreDashboardOperationsButtons } from 'core/components'
import { Icons } from 'stylewhere/components'
import { __ } from 'stylewhere/i18n'
import { Router } from 'stylewhere/shared'
import { canViewDeskNotice } from 'custom/cucinelli/shared/utils'

interface Props {
  refreshCounter: number
}

export const DashboardOperationsButtons = ({ refreshCounter }: Props) => {
  // cast necessario: le rotte custom non sono nel tipo Routes (brand "none") a compile-time
  const goToDeskNotice = () => Router.navigate('/desk-notice' as any)

  const deskNoticeButton = canViewDeskNotice()
    ? [{ code: 'desk-notice', icon: <Icons.TagInfo />, text: __('desk_notice.title'), onClick: goToDeskNotice }]
    : []

  return <CoreDashboardOperationsButtons refreshCounter={refreshCounter} prependButtons={deskNoticeButton} />
}
